export default "__VITE_ASSET__C8FZTB9KZW61b1q05gBpPw__"